import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Branches from "@/pages/Branches";
import Personnel from "@/pages/Personnel";
import Devamsizlik from "@/pages/Devamsizlik";
import YillikIzin from "@/pages/YillikIzin";
import Evraklar from "@/pages/Evraklar";
import PersonnelLogin from "@/pages/PersonnelLogin";
import PersonnelPortal from "@/pages/PersonnelPortal";
import Bills from "@/pages/Bills";
import Masraflar from "@/pages/Masraflar";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] text-slate-400">
        Yükleniyor…
      </div>
    );
  if (!user) return <Navigate to="/giris" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
    if (localStorage.getItem("theme") === "light") document.documentElement.classList.add("light");
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/giris" element={<LoginRoute />} />
            <Route path="/personel-giris" element={<PersonnelLogin />} />
            <Route path="/portal" element={<PersonnelPortal />} />
            <Route
              element={
                <Protected>
                  <AppLayout />
                </Protected>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/subeler" element={<Branches />} />
              <Route path="/personel" element={<Personnel />} />
              <Route path="/devamsizlik" element={<Devamsizlik />} />
              <Route path="/yillik-izin" element={<YillikIzin />} />
              <Route path="/evraklar" element={<Evraklar />} />
              <Route path="/faturalar" element={<Bills />} />
              <Route path="/masraflar" element={<Masraflar />} />
              <Route path="/raporlar" element={<Reports />} />
              <Route path="/kullanicilar" element={<Users />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
